import useConfigs from '@/util/configs';

// eslint-disable-next-line import/prefer-default-export
export const AuthRoutes = {
  azureLoginRoute: () => {
    const {
      BASE_URL,
      POLICY_ID,
      CLIENT_ID,
      NONCE,
      SCOPE,
      RESPONSE,
      PROMPT,
    } = useConfigs().AZURE_LOGIN_PAGE;

    return `${BASE_URL}?p=${POLICY_ID}&client_id=${CLIENT_ID}&nonce=${NONCE}&scope=${SCOPE}&response_type=${RESPONSE}&prompt=${PROMPT}&redirect_uri=${window.location.origin}`;
  },
};
